const initualState = {
  rewardHistory: {
    from: new Date(),
    to: new Date(),
    reportType: 1,
    result: []
  },
  redemption: {
    redemptionCurrency: "",
    dashboard: undefined
  }
};

export default (state = initualState, action) => {
  switch (action.type) {
    case "SET_REWARD_SYSTEM_HISTORY_DATA":
      return {
        ...state,
        rewardHistory: { ...state.rewardHistory, ...action.payload }
      };
    case "SET_REDEMPTION_DATA":
      return {
        ...state,
        redemption: { ...state.redemption, ...action.payload }
      };

    case "SET_REDEMPTION_GRAPH DATA":
      return {
        ...state,
        redemption: { ...state.redemption, dashboard: action.payload }
      };
    case "SET_REWARD_HISTORY_RESULT":
      return {
        ...state,
        rewardHistory: { ...state.rewardHistory, result: action.payload }
      };
    default:
      return state;
  }
};
